import 'whatwg-fetch';
import axios from "axios";
import router from '../routes/router';

let _apiPrefix = 'https://development.easydrive2-api.rietveld.nl/v1/'
// let _apiPrefix = window.location.protocol + '//' + window.location.hostname + ':9090/v1/'
// let _apiPrefix = 'http://development.easydrive2-api.rietveld.nl/v1'
let _apiPrefixSync = 'https://development.easydrive2-api-sync.rietveld.nl/sync/v1/'
// let _apiPrefixSync = window.location.protocol + '//' + window.location.hostname + ':9092/sync/v1/'
let _apiPrefixAdmin = 'https://development.easydrive2-api-admin.rietveld.nl/admin/v1/'
// let _apiPrefixAdmin = window.location.protocol + '//' + window.location.hostname + ':9091/admin/v1/'

const axiosInstance = axios.create({
  baseURL: _apiPrefix,
  headers: {
    "Accept": "application/nl.rietveld.easydrive2.v1+json, application/octet-stream",
    "Content-Type": "application/nl.rietveld.easydrive2.v1+json"
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
      config.headers["X-API-Key"] = 'Token ' + user.accessToken
    } else {
      let monitoring = JSON.parse(localStorage.getItem('monitoring'));

      if (monitoring && monitoring.accessToken) {
        config.headers["X-API-Key"] = 'Token ' + monitoring.accessToken
      }
    }

    console.log('Request => ' + config.method + ' ' + config.baseURL + config.url)

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const axiosInstanceAdmin = axios.create({
  baseURL: _apiPrefixAdmin,
  headers: {
    "Accept": "application/nl.rietveld.easydrive2.v1+json",
    "Content-Type": "application/nl.rietveld.easydrive2.v1+json"
  },
});

axiosInstanceAdmin.interceptors.request.use(
  (config) => {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
      config.headers["X-API-Key"] = 'Token ' + user.accessToken
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceAdmin.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    return Promise.reject(err);
  }
);

const axiosInstanceSync = axios.create({
  baseURL: _apiPrefixSync,
  headers: {
    "Accept": "application/nl.rietveld.easydrive2.v1+json",
    "Content-Type": "application/nl.rietveld.easydrive2.v1+json"
  },
});

axiosInstanceSync.interceptors.request.use(
  (config) => {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
      config.headers["X-API-Key"] = 'Token ' + user.accessToken
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceSync.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    return Promise.reject(err);
  }
);

let originalConfig = undefined

axiosInstance.interceptors.response.use(
  (res) => {

    console.log('Response => ', res.status + ' ' + res.statusText + ' ' + res.config.method + ' ' + res.config.baseURL + res.config.url)

    return res;
  },
  async (err) => {
    if (originalConfig === undefined || !originalConfig._refreshToken) {
      originalConfig = err.config;
    }

    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && err.response.data && err.response.data.code === "TOKEN_EXPIRED" && (!originalConfig._retry || originalConfig._refreshToken)) {
        originalConfig._retry = true;

        if (originalConfig._refreshToken) {
          crudApi.logout()

          originalConfig = undefined
        } else {
          try {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.refreshToken) {
              originalConfig._refreshToken = true

              await crudApi.refreshToken({ "refreshToken": user.refreshToken })

              return axiosInstance(originalConfig);
            }

            return axiosInstance(originalConfig);
          } catch (_error) {
            if (_error.response && _error.response.data) {
              return Promise.reject(_error.response.data);
            }

            return Promise.reject(_error);
          }
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);

const crudApi = {
    login(organisation, username, password) {
      return axiosInstance.post('login',{
          organisation: organisation,
          username: username,
          password: password
        })
        .then(response => {
          return handleTokenResponse(response)
        })
    },

    logout() {
      localStorage.removeItem('user')

      router.push('/login')
    },

    refreshToken(token) {
      return axiosInstance.post('refresh', token)
        .then(response => {
          return handleTokenResponse(response)
        })
    },

    getRemoteOrganisations(server) {
      return axiosInstanceSync.get('organisations?server='+server)
    },

    getOrganisations() {
      return axiosInstance.get('organisations')
    },

    getOrganisation(organisationId) {
      return axiosInstance.get('organisations/' + organisationId)
    },

    getOrganisationAssetOverview(organisationId, entities = false) {
      return axiosInstance.get('organisations/' + organisationId + '/assets/fleet?entities='+entities)
    },

    createOrganisation(organisationId, data) {
      return axiosInstance.post('organisations/' + organisationId, data)
    },

    getOrganisationSettings(organisationId) {
      return axiosInstance.get('organisations/' + organisationId + '/settings')
    },

    createOrganisationSettings(organisationId, data) {
      return axiosInstance.post('organisations/' + organisationId + '/settings', data)
    },

    updateOrganisationSettings(organisationSettings) {
      return axiosInstance.put('organisationsettings/' + organisationSettings.id, organisationSettings)
    },

    getDevice(deviceId) {
      return axiosInstance.get('/devices/' + deviceId)
    },

    getAsset(assetId) {
      return axiosInstance.get('/assets/' + assetId)
    },

    getDriver(driverId) {
      return axiosInstance.get('/drivers/' + driverId)
    },

    getUser(userId) {
      return axiosInstance.get('/users/' + userId)
    },

    getAssetMonitoring(id) {
      return axiosInstance.get('/assetmonitorings/' + id)
    },

    getAssetMonitoringToken(id) {
      return axiosInstance.get('/assetmonitorings/' + id + '/token')
    },

    createAssetAssetMonitoringRequest(assetId, request) {
      return axiosInstance.post('/assets/' + assetId + '/assetmonitoringrequests', request)
    },

    getAssetAssetMonitoringRequests(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('/assets/' + assetId + '/assetmonitoringrequests?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('/assets/' + assetId + '/assetmonitoringrequests?from=' + toIsoString(from))
      }
    },

    getAll(route, organisationId) {
        return axiosInstance.get('organisations/' + organisationId + '/' + route)
    },

    getGroupMembers(groupId) {
        return axiosInstance.get('/groups/' + groupId + '/membercandidates')
    },

    addAssetToGroup(groupId, assetId) {
      return axiosInstance.put('/groups/' + groupId + '/assets/' + assetId)
    },

    addDriverToGroup(groupId, driverId) {
      return axiosInstance.put('/groups/' + groupId + '/drivers/' + driverId)
    },

    deleteAssetFromGroup(groupId, assetId) {
      return axiosInstance.delete('/groups/' + groupId + '/assets/' + assetId)
    },

    deleteDriverFromGroup(groupId, driverId) {
      return axiosInstance.delete('/groups/' + groupId + '/drivers/' + driverId)
    },

    getConfigurationGroupMembers(groupId) {
      return axiosInstance.get('/configurationgroups/' + groupId + '/membercandidates')
    },

    addAssetToConfigurationGroup(groupId, assetId) {
      return axiosInstance.put('/configurationgroups/' + groupId + '/assets/' + assetId)
    },

    deleteAssetFromConfigurationGroup(groupId, assetId) {
      return axiosInstance.delete('/configurationgroups/' + groupId + '/assets/' + assetId)
    },

    getAllVehicleDrivingStyleData(organisationId, from, until, ids, groupIds, trips, interval, minimumDistance = 100, driverLinkExtendTime = 300, includePreviousData = false) {
      let url = '/organisations/' + organisationId + '/reports/assets';

      let data = {
        from: toIsoStringEncode(from, false),
        until: toIsoStringEncode(until, false),
        scoreData: true,
        drivingStyleData: true,
        trips: trips,
        minimumDistance: minimumDistance,
        driverLinkExtendTime: driverLinkExtendTime,
        includePreviousData: includePreviousData
      }

      if (interval) {
        data.interval = interval
      }

      if (ids !== undefined) {
        data.id = ids
      } else if (groupIds !== undefined) {
        data.group = groupIds
      } else {
        data.group = [ 'ALL' ]
      }

      return axiosInstance.post(url, data)
    },

    getAllDriverDrivingStyleData(organisationId, from, until, ids, groupIds, trips, interval, minimumDistance = 100, driverLinkExtendTime = 300) {
      let url = '/organisations/' + organisationId + '/reports/drivers';

      let data = {
        from: toIsoStringEncode(from, false),
        until: toIsoStringEncode(until, false),
        scoreData: true,
        drivingStyleData: true,
        trips: trips,
        minimumDistance: minimumDistance,
        driverLinkExtendTime: driverLinkExtendTime
      }

      if (interval) {
        data.interval = interval
      }

      if (ids) {
        data.id = ids
      } else if (groupIds) {
        data.group = groupIds
      } else {
        data.group = [ 'ALL' ]
      }

      return axiosInstance.post(url, data)
    },

    getVehicleTrips(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/trips?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/trips?from=' + toIsoString(from))
      }
    },

    getAssetEvents(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/events?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/events?from=' + toIsoString(from))
      }
    },

    getAssetRawDatas(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/rawdatas?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/rawdatas?from=' + toIsoString(from))
      }
    },

    getAssetDatapoints(assetId, from, until, events, media) {
      from.setSeconds(from.getSeconds() - 1)

      if (until !== undefined) {
        until.setSeconds(until.getSeconds() + 1);

        return axiosInstance.get('assets/' + assetId + '/datapoints?from=' + toIsoString(from) + "&until=" + toIsoString(until) + "&events=" + events + "&media=" + media)
      } else {
        return axiosInstance.get('assets/' + assetId + '/datapoints?from=' + toIsoString(from) + "&events=" + events + "&media=" + media)
      }
    },

    getDriverEvents(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('drivers/' + assetId + '/events?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('drivers/' + assetId + '/events?from=' + toIsoString(from))
      }
    },

    getDeviceLinks(deviceId, from) {
      return axiosInstance.get('devices/' + deviceId + '/devicelinks?from=' + toIsoString(from))
    },

    createAssetDeviceLink(assetId, deviceId, from) {
      return axiosInstance.put('/assets/' + assetId + '/devices/' + deviceId + '?from=' + toIsoString(from))
    },

    terminateAssetDeviceLink(assetId, deviceId, until) {
      return axiosInstance.delete('/assets/' + assetId + '/devices/' + deviceId + '?until=' + toIsoString(until))
    },

    deleteDeviceLink(id) {
      return axiosInstance.delete('/devicelinks/' + id)
    },

    getDriverLinks(driverId, from) {
      return axiosInstance.get('drivers/' + driverId + '/driverlinks?from=' + toIsoString(from))
    },

    createAssetDriverLink(assetId, driverId, from) {
      return axiosInstance.put('/assets/' + assetId + '/drivers/' + driverId + '?from=' + toIsoString(from))
    },

    terminateAssetDriverLink(assetId, driverId, until) {
      return axiosInstance.delete('/assets/' + assetId + '/drivers/' + driverId + '?until=' + toIsoString(until))
    },

    deleteDriverLink(id) {
      return axiosInstance.delete('/driverlinks/' + id)
    },

    getDeviceConfigurations() {
      return axiosInstance.get('deviceconfigurations')
    },

    getGroups(organisationId) {
      return axiosInstance.get('organisations/' + organisationId + '/groups')
    },

    getConfigurationGroupConfigurations(configurationGroupId) {
      return axiosInstance.get('configurationgroups/' + configurationGroupId + '/deviceconfigurations?defaults=true&definitions=true')
    },

    updateConfigurationGroupConfigurations(configurationGroupId, data) {
      return axiosInstance.post('configurationgroups/' + configurationGroupId + '/deviceconfigurations', data)
    },

    getMedia(id) {
      return axiosInstance.get('media/' + id)
    },

    downloadMedia(id) {
      return axiosInstance.get('media/' + id + '/download', { responseType: 'arraybuffer' })
    },

    downloadMediaThumbnail(id) {
      return axiosInstance.get('media/' + id + '/thumbnail', { responseType: 'arraybuffer' })
    },

    deleteMedia(id) {
      return axiosInstance.delete('media/' + id)
    },

    uploadMedia(identifier, timestamp, mimeType, file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("identifier", identifier)
      formData.append("timestamp", timestamp)
      formData.append("mimeType", mimeType)

      axiosInstance.post('media/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },

    getAssetMedia(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/media?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/media?from=' + toIsoString(from))
      }
    },

    getDriverMedia(driverId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('drivers/' + driverId + '/media?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('drivers/' + driverId + '/media?from=' + toIsoString(from))
      }
    },

    createAssetMediaRequest(assetId, request) {
      return axiosInstance.post('assets/' + assetId + '/mediarequests', request)
    },

    createDriverMediaRequest(driverId, request) {
      return axiosInstance.post('drivers/' + driverId + '/mediarequests', request)
    },

    getAssetMediaRequests(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/mediarequests?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/mediarequests?from=' + toIsoString(from))
      }
    },

    getDriverMediaRequests(driverId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('drivers/' + driverId + '/mediarequests?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('drivers/' + driverId + '/mediarequests?from=' + toIsoString(from))
      }
    },

    getMediaRequestMedias(mediaRequestId) {
      return axiosInstance.get('mediarequests/' + mediaRequestId + '/medias')
    },

    getAssetMonitorings(assetId, from, until) {
      if (until !== undefined) {
        return axiosInstance.get('assets/' + assetId + '/assetmonitorings?from=' + toIsoString(from) + "&until=" + toIsoString(until))
      } else {
        return axiosInstance.get('assets/' + assetId + '/assetmonitorings?from=' + toIsoString(from))
      }
    },

    getActiveAssetMonitoring(assetId) {
      return axiosInstance.get('assets/' + assetId + '/assetmonitorings/active')
    },

    endAssetMonitoring(id) {
      return axiosInstance.put('assetmonitorings/' + id + '/end')
    },

    post(organisationId, route, data) {
        return axiosInstance.post('organisations/' + organisationId + '/' + route, data)
    },

    put(route, data) {
        return axiosInstance.put(route + '/' + data.id, data)
    },

    delete(route, id) {
        return axiosInstance.delete(route + '/' + id)
    },

    importRawDatas(requestObject, from, until) {
      return axiosInstanceAdmin.post('/rawdatas/import?from=' + toIsoString(from) + '&until=' + toIsoString(until), requestObject)
    },

    recalculateQueryPoints(assetId, from, until) {
      return axiosInstanceAdmin.get('/assets/' + assetId + '/querypoints?from=' + toIsoString(from) + '&until=' + toIsoString(until))
    },

    recalculateDriverLinks(assetId, from, until) {
      return axiosInstanceAdmin.get('/assets/' + assetId + '/driverlinks?from=' + toIsoString(from) + '&until=' + toIsoString(until))
    },

    deleteAllOrganisationData(organisationId) {
      return axiosInstanceAdmin.delete('/organisations/' + organisationId + '/data')
    },

    syncOrganisation(organisationId) {
      return axiosInstanceSync.put('organisations/' + organisationId + '/sync')
    },

    updateOrganisationExternalIDs(organisationId) {
      return axiosInstanceSync.put('organisations/' + organisationId + '/externalids')
    },

    getSyncConfiguration(organisationId) {
      return axiosInstanceSync.get('organisations/' + organisationId + '/configuration')
    },

    createSyncConfiguration(organisationId, configuration) {
      return axiosInstanceSync.post('organisations/' + organisationId + '/configuration', configuration)
    },

    updateSyncConfiguration(configuration) {
      return axiosInstanceSync.put('configurations/' + configuration.id, configuration)
    },

    getSyncResults(organisationId, from, until) {
      return axiosInstanceSync.get('organisations/' + organisationId + '/results?from=' + toIsoString(from) + '&until=' + toIsoString(until))
    },

    getLastSyncResults() {
      return axiosInstanceSync.get('lastresults/')
    }

};

function handleTokenResponse(response) {
  if (response.data.accessToken) {
    let userData = {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken,
    }

    let tokenPayload = parseJwt(response.data.accessToken)

    userData.user_organisation_id = tokenPayload.organisation_id
    userData.organisation_id = tokenPayload.organisation_id
    userData.user_id = tokenPayload.user_id
    userData.user_role = tokenPayload.user_role

    localStorage.setItem('user', JSON.stringify(userData));

    originalConfig = undefined // bit of a hack for automatic token renewal
  }

  return response.data;
}

function parseJwt(token) {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

function toIsoString(date) {
  return toIsoStringEncode(date, true)
}

function toIsoStringEncode(date, encode) {
  let tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function(num) {
      return (num < 10 ? '0' : '') + num;
    };

  if (encode) {
    dif = tzo >= 0? '%2B' : '%2D'
  }

  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    dif + pad(Math.floor(Math.abs(tzo) / 60)) +
    ':' + pad(Math.abs(tzo) % 60);
}

export default crudApi;
